import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";

import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import useMediaQuery from "@material-ui/core/useMediaQuery";

import {
  textfield,
  switchControl,
  selectField,
  defaultPasscodeTheme,
  getSelectValues,
  getSelectedValueTranslated,
  getKeyFromSelectedValue,
} from "../../../constants/passCodeUtils";

import { MIN_DESKTOP_WIDTH } from "../../../constants/ui";

import {
  UNATTENDED_DIALOUT_ALLOWED,
  PARAM_AFTER_CONFERENCE_REPORT,
  PARAM_ONE_TIME,
  ONE_TIME,
  RECORD_CONFERENCE,
  DIALOUT_MODE,
  ALLOW_CONFERENCE_PROJECTCODE,
  RECORD_CODE,
  AFTER_CONFERENCE_EMAIL,
  FORCE_PROMPT_CAS_DIALOUTS,
  SUB_CONFERENCE_ENABLED,
  WEB_PRESENTER,
  AFTER_CONFERENCE_REPORT,
} from "../../../utils/responseValue";

const useStyles = makeStyles(theme => ({
  ...defaultPasscodeTheme(theme),
  readOnly: {
    backgroundColor: "#ffffff",
    borderRadius: "5px",
  },
}));

const PMGeneralOptions = ({ confRestRep, setConfRestRep, selectValues, translate }) => {
  const classes = useStyles();
  const isDesktop = useMediaQuery(`(min-width:${MIN_DESKTOP_WIDTH})`);

  const handleTextChange = name => event => {
    setConfRestRep({ ...confRestRep, [name]: event.target.value });
  };

  const handleSwitchChange = name => event => {
    setConfRestRep({ ...confRestRep, [name]: event.target.checked });
  };
  const handleSelectChange = (name, confKey) => event => {
    setConfRestRep({
      ...confRestRep,
      [confKey || name]: getKeyFromSelectedValue(selectValues[name], event.target.value),
    });
  };

  const customStyle = () => ({
    formControl: {
      width: "200px",
    },
  });

  return (
    <form className={classes.container} noValidate autoComplete="off">
      <div className={classes.centerer}>
        {selectField(
          customStyle,
          translate[ONE_TIME],
          getSelectValues(selectValues, PARAM_ONE_TIME),
          getSelectedValueTranslated(confRestRep[ONE_TIME], selectValues, PARAM_ONE_TIME),
          handleSelectChange(PARAM_ONE_TIME, ONE_TIME)
        )}
        {selectField(
          customStyle,
          translate[RECORD_CONFERENCE],
          getSelectValues(selectValues, RECORD_CONFERENCE),
          getSelectedValueTranslated(confRestRep[RECORD_CONFERENCE], selectValues, RECORD_CONFERENCE),
          handleSelectChange(RECORD_CONFERENCE)
        )}
        {selectField(
          customStyle,
          translate[DIALOUT_MODE],
          getSelectValues(selectValues, UNATTENDED_DIALOUT_ALLOWED),
          getSelectedValueTranslated(confRestRep[DIALOUT_MODE], selectValues, UNATTENDED_DIALOUT_ALLOWED),
          handleSelectChange(UNATTENDED_DIALOUT_ALLOWED, DIALOUT_MODE)
        )}
        {selectField(
          customStyle,
          translate[ALLOW_CONFERENCE_PROJECTCODE],
          getSelectValues(selectValues, ALLOW_CONFERENCE_PROJECTCODE),
          getSelectedValueTranslated(
            confRestRep[ALLOW_CONFERENCE_PROJECTCODE],
            selectValues,
            ALLOW_CONFERENCE_PROJECTCODE
          ),
          handleSelectChange(ALLOW_CONFERENCE_PROJECTCODE)
        )}
      </div>
      <div className={classes.lineBreak} />
      <TextField
        label={translate[RECORD_CODE]}
        className={clsx(
          classes.textField,
          {
            [classes.lineExpander]: isDesktop,
            [classes.textFieldMobile]: !isDesktop,
          },
          classes.readOnly
        )}
        value={confRestRep[RECORD_CODE] || ""}
        margin="normal"
        InputProps={{
          readOnly: true,
        }}
      />
      <div className={classes.lineBreak} />
      {textfield(
        classes,
        isDesktop,
        confRestRep[AFTER_CONFERENCE_EMAIL],
        translate[AFTER_CONFERENCE_EMAIL],
        handleTextChange(AFTER_CONFERENCE_EMAIL)
      )}
      <div className={classes.lineBreak} />
      {switchControl(
        classes,
        confRestRep[FORCE_PROMPT_CAS_DIALOUTS],
        FORCE_PROMPT_CAS_DIALOUTS,
        translate[FORCE_PROMPT_CAS_DIALOUTS],
        handleSwitchChange(FORCE_PROMPT_CAS_DIALOUTS)
      )}
      <div className={classes.lineBreak} />
      {switchControl(
        classes,
        confRestRep[SUB_CONFERENCE_ENABLED],
        SUB_CONFERENCE_ENABLED,
        translate[SUB_CONFERENCE_ENABLED],
        handleSwitchChange(SUB_CONFERENCE_ENABLED)
      )}
      <div className={classes.lineBreak} />
      {switchControl(
        classes,
        confRestRep[WEB_PRESENTER],
        WEB_PRESENTER,
        translate[WEB_PRESENTER],
        handleSwitchChange(WEB_PRESENTER)
      )}
      <div className={classes.lineBreak} />
      {selectField(
        customStyle,
        translate[AFTER_CONFERENCE_REPORT],
        getSelectValues(selectValues, PARAM_AFTER_CONFERENCE_REPORT),
        getSelectedValueTranslated(confRestRep[AFTER_CONFERENCE_REPORT], selectValues, PARAM_AFTER_CONFERENCE_REPORT),
        handleSelectChange(PARAM_AFTER_CONFERENCE_REPORT, AFTER_CONFERENCE_REPORT)
      )}
    </form>
  );
};

PMGeneralOptions.propTypes = {
  confRestRep: PropTypes.object.isRequired,
  selectValues: PropTypes.object.isRequired,
  setConfRestRep: PropTypes.func.isRequired,
  translate: PropTypes.object.isRequired,
};

export default PMGeneralOptions;
